import { s as styleInject, _ as __rest, a as __assign, p as passThroughProps, U as UserIcon, T as Tabs, b as Tab, c as __extends, R as RichJavascriptEditor, m as makeDOMEvent, A as AddDependencyDialog } from './index-7f1490f0.js';
import React, { Component } from 'react';
import Button from '@leafygreen-ui/button';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { faBan, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-dd-menu';
import 'react-confirm';
import '@leafygreen-ui/checkbox';
import '@leafygreen-ui/modal';
import '@leafygreen-ui/typography';
import 'react-fontawesome';
import 'react-transition-group';
import '@leafygreen-ui/confirmation-modal';
import '@leafygreen-ui/text-input';
import '@leafygreen-ui/banner';
import '@leafygreen-ui/icon';
import '@leafygreen-ui/palette';
import '@leafygreen-ui/code';
import '@leafygreen-ui/icon/dist/X';
import '@leafygreen-ui/icon-button';
import '@leafygreen-ui/select';
import '@leafygreen-ui/badge';
import '@leafygreen-ui/icon/dist/Plus';
import 'moment';
import '@leafygreen-ui/copyable';
import 'react-tooltip';
import '@leafygreen-ui/toast';
import 'baas-admin-sdk';
import '@leafygreen-ui/radio-box-group';
import 'cron-parser';
import 'react-select';
import '@leafygreen-ui/toggle';
import '@leafygreen-ui/tooltip';
import 'semver/functions/coerce';
import 'semver/functions/gte';
import '@leafygreen-ui/card';
import 'react-through';

var CONSOLE_SOURCE_DEFAULT = "/*\n  To Run the function:\n    - Select a user\n    - Type 'exports()' to run the function with no arguments\n    - Type 'exports(arg1, arg2, args...)'  to run the function with arguments\n    - To run a saved function type 'context.functions.execute(<function-name-string>, args...)'\n    - Click 'Run function as'\n*/";

var css_248z$1 = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.debug-console-editor {\n  display: flex;\n  flex-flow: column;\n}\n.debug-console-editor > div {\n  font-size: 13px;\n  font-style: normal;\n  font-family: 'Menlo', 'Monaco', 'Consolas', 'Courier New', 'Ubuntu Mono', 'source-code-pro', monospace;\n}\n.debug-console-result {\n  display: flex;\n  flex-flow: column;\n}\n.debug-console-result > div {\n  font-size: 13px;\n  font-style: normal;\n  font-family: 'Menlo', 'Monaco', 'Consolas', 'Courier New', 'Ubuntu Mono', 'source-code-pro', monospace;\n}\n.debug-console-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n  position: relative;\n  bottom: 0;\n  z-index: 10;\n}\n.debug-console-drawer {\n  border: 1px solid #bfbfbe;\n  display: flex;\n  flex-flow: column;\n  min-height: 37px;\n  transition: box-shadow 0.3s ease-in-out;\n}\n.debug-console-drawer-header {\n  align-items: center;\n  background-color: #f1f1f1;\n  color: #888888;\n  display: flex;\n  flex-direction: row;\n  min-height: 37px;\n  max-height: 37px;\n}\n.debug-console-drawer-header-is-open {\n  border-bottom: 1px solid #bfbfbe;\n}\n.debug-console-drawer-header-content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n.debug-console-drawer-header-content-actions {\n  font-size: 12px;\n  font-weight: 500;\n  align-items: center;\n  margin-right: 5px;\n  display: flex;\n}\n.debug-console-drawer-header-button {\n  border-radius: 0;\n  margin-right: 5px;\n  font-size: 12px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  background: white;\n  box-shadow: none;\n  min-width: 40px;\n}\n.debug-console-drawer-header-button svg {\n  stroke: #464c4f;\n  height: 12px;\n}\n.debug-console-drawer-header-button .tb-svg-is-margin-right {\n  margin-right: 7px;\n}\n.debug-console-drawer-header-button-user {\n  margin-right: -1px;\n}\n.debug-console-drawer-header-button.tb-button-is-disabled {\n  background: none;\n  border-color: #dee0e3;\n}\n.debug-console-drawer-header-button.tb-button-is-disabled svg g {\n  stroke: #888888;\n}\n.debug-console-drawer-header-button .fa {\n  margin-right: 7px;\n}\n.debug-console-drawer-header-button-toggle {\n  align-items: center;\n  width: 100%;\n}\n.debug-console-drawer-header-button-toggle .fa {\n  margin-right: 0px;\n  font-size: 20px;\n}\n.debug-console-drawer-header-button:focus {\n  border-radius: 0px;\n  margin-right: 5px;\n  font-size: 12px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  background: white;\n  height: 70%;\n  box-shadow: none;\n  min-width: 40px;\n}\n.debug-console-drawer-header-toggle {\n  align-items: center;\n  cursor: pointer;\n  margin-left: auto;\n  color: #494747;\n  font-size: 25px;\n  margin-right: 15px;\n  transition: transform 0.3s ease-in-out;\n  transform: rotate(0deg);\n}\n.debug-console-drawer-header-toggle-open {\n  transition: transform 0.3s ease-in-out;\n  transform: rotate(180deg);\n}\n.debug-console-drawer-header-is-open {\n  cursor: row-resize;\n}\n.debug-console-drawer-header-is-resizing {\n  background-color: #f3f3f3;\n  cursor: row-resize;\n}\n.debug-console-drawer-content {\n  display: flex;\n  flex-flow: column;\n}\n";
styleInject(css_248z$1);

var ConsoleDrawer = /* #__PURE__ */ (function () {
    var ConsoleDrawer = function (_a) {
        var open = _a.open, resizing = _a.resizing, headerContent = _a.headerContent, children = _a.children, handleResizeMouseDown = _a.handleResizeMouseDown, rest = __rest(_a, ["open", "resizing", "headerContent", "children", "handleResizeMouseDown"]);
        return (React.createElement("div", __assign({ className: "debug-console-drawer" }, passThroughProps(rest)),
            React.createElement("div", { className: classNames('debug-console-drawer-header', {
                    'debug-console-drawer-header-is-open': open,
                    'debug-console-drawer-header-is-resizing': resizing,
                }), onMouseDown: handleResizeMouseDown },
                React.createElement("div", { className: "debug-console-drawer-header-content" }, headerContent)),
            React.createElement("div", { className: "debug-console-drawer-content" }, open ? children : null)));
    };
    ConsoleDrawer.propTypes = {
        open: PropTypes.bool,
        resizing: PropTypes.bool,
        headerContent: PropTypes.node,
        children: PropTypes.node,
        handleResizeMouseDown: PropTypes.func,
    };
    ConsoleDrawer.defaultProps = {
        open: false,
        resizing: false,
        headerContent: '',
        children: null,
        handleResizeMouseDown: null,
    };
    return ConsoleDrawer;
})();

var RunFunctionIcon = /* #__PURE__ */ (function () {
    var RunFunctionIcon = function (_a) {
        var className = _a.className;
        return (React.createElement("svg", { width: "12px", height: "15px", viewBox: "0 0 12 15", version: "1.1", className: className },
            React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                React.createElement("g", { id: "functions-3a-copy-2", transform: "translate(-246.000000, -845.000000)", stroke: "#888888", strokeWidth: "2" },
                    React.createElement("g", { id: "Group-3", transform: "translate(235.000000, 242.000000)" },
                        React.createElement("g", { id: "Group-4", transform: "translate(2.000000, 591.000000)" },
                            React.createElement("g", { id: "Group-13", transform: "translate(9.000000, 8.000000)" },
                                React.createElement("g", { id: "Group-11", transform: "translate(0.000000, 3.000000)" },
                                    React.createElement("path", { d: "M10.7768385,8.49995663 L1,2.20832354 L1,14.7915897 L10.7768385,8.49995663 Z", id: "Triangle" })))))))));
    };
    RunFunctionIcon.propTypes = {
        className: PropTypes.string,
    };
    RunFunctionIcon.defaultProps = {
        className: '',
    };
    return RunFunctionIcon;
})();

var RUN_FUNCTION_ID = 'runFunction';
var ConsoleBarActions = /* #__PURE__ */ (function () {
    var ConsoleBarActions = function (_a) {
        var disableClear = _a.disableClear, disableRun = _a.disableRun, onClear = _a.onClear, onChangeUser = _a.onChangeUser, open = _a.open, onRun = _a.onRun, selectedUser = _a.selectedUser, onToggle = _a.onToggle, showUserActions = _a.showUserActions, rest = __rest(_a, ["disableClear", "disableRun", "onClear", "onChangeUser", "open", "onRun", "selectedUser", "onToggle", "showUserActions"]);
        return (React.createElement("div", __assign({ className: "debug-console-drawer-header-content-actions" }, passThroughProps(rest)),
            showUserActions && (React.createElement(React.Fragment, null,
                React.createElement(Button, { disabled: true, name: "selectedUser", className: "debug-console-drawer-header-button debug-console-drawer-header-button-user" },
                    React.createElement(UserIcon, { className: "tb-svg-is-margin-right" }),
                    selectedUser),
                React.createElement(Button, { name: "changeUser", className: "debug-console-drawer-header-button", onClick: onChangeUser }, "Change User"))),
            React.createElement(Button, { id: RUN_FUNCTION_ID, name: "runFunction", className: "debug-console-drawer-header-button", onClick: onRun, disabled: disableRun },
                React.createElement(RunFunctionIcon, { className: "tb-svg-is-margin-right" }),
                "Run"),
            React.createElement(Button, { name: "clearResult", className: "debug-console-drawer-header-button", onClick: onClear, disabled: disableClear },
                React.createElement(FontAwesomeIcon, { className: "tb-svg-is-margin-right", icon: faBan }),
                " Clear Result"),
            React.createElement(Button, { className: "debug-console-drawer-header-button", onClick: onToggle },
                React.createElement("div", { className: "debug-console-drawer-header-button-toggle" },
                    React.createElement(FontAwesomeIcon, { icon: open ? faChevronDown : faChevronUp })))));
    };
    ConsoleBarActions.propTypes = {
        disableClear: PropTypes.bool,
        disableRun: PropTypes.bool,
        onChangeUser: PropTypes.func,
        onClear: PropTypes.func,
        onRun: PropTypes.func,
        onToggle: PropTypes.func,
        open: PropTypes.bool,
        selectedUser: PropTypes.string,
        showUserActions: PropTypes.bool,
    };
    ConsoleBarActions.defaultProps = {
        disableClear: true,
        disableRun: false,
        onChangeUser: function () { },
        onClear: function () { },
        onRun: function () { },
        onToggle: function () { },
        selectedUser: undefined,
        open: false,
        showUserActions: false,
    };
    return ConsoleBarActions;
})();

var CONSOLE_TAB = 'Console';
var RESULT_TAB = 'Result';
var ConsoleTabs = /* #__PURE__ */ (function () {
    var ConsoleTab = function (_a) {
        var onClick = _a.onClick, active = _a.active, display = _a.display;
        return (React.createElement(Tab, { variant: "debugConsole", onClick: onClick, active: active },
            React.createElement("a", null, display)));
    };
    ConsoleTab.propTypes = {
        onClick: PropTypes.func.isRequired,
        active: PropTypes.bool.isRequired,
        display: PropTypes.string.isRequired,
    };
    var ConsoleTabs = function (_a) {
        var activeTab = _a.activeTab, onChangeTab = _a.onChangeTab, rest = __rest(_a, ["activeTab", "onChangeTab"]);
        return (React.createElement(Tabs, __assign({ variant: "debugConsole" }, passThroughProps(rest)),
            React.createElement(ConsoleTab, { onClick: function (e) { return onChangeTab(CONSOLE_TAB, e); }, active: activeTab === CONSOLE_TAB, display: CONSOLE_TAB }),
            React.createElement(ConsoleTab, { onClick: function (e) { return onChangeTab(RESULT_TAB, e); }, active: activeTab === RESULT_TAB, display: RESULT_TAB })));
    };
    ConsoleTabs.propTypes = {
        activeTab: PropTypes.string,
        onChangeTab: PropTypes.func,
    };
    ConsoleTabs.defaultProps = {
        activeTab: '',
        onChangeTab: function () { },
    };
    return ConsoleTabs;
})();

var ConsoleHeader = /* #__PURE__ */ (function () {
    var ConsoleHeader = function (_a) {
        var activeTab = _a.activeTab, disableClear = _a.disableClear, disableRun = _a.disableRun, onChangeUser = _a.onChangeUser, onClear = _a.onClear, onChangeTab = _a.onChangeTab, onRun = _a.onRun, onToggle = _a.onToggle, open = _a.open, selectedUser = _a.selectedUser, showUserActions = _a.showUserActions, rest = __rest(_a, ["activeTab", "disableClear", "disableRun", "onChangeUser", "onClear", "onChangeTab", "onRun", "onToggle", "open", "selectedUser", "showUserActions"]);
        return (React.createElement("div", __assign({ className: "debug-console-drawer-header-content" }, passThroughProps(rest)),
            React.createElement("div", { className: "debug-console-drawer-header-content-tabs", onClick: onToggle },
                React.createElement(ConsoleTabs, { activeTab: activeTab, onChangeTab: onChangeTab })),
            React.createElement(ConsoleBarActions, { disableClear: disableClear, disableRun: disableRun, onClear: onClear, onRun: onRun, onChangeUser: onChangeUser, onToggle: onToggle, open: open, selectedUser: selectedUser, showUserActions: showUserActions })));
    };
    ConsoleHeader.propTypes = {
        activeTab: PropTypes.string.isRequired,
        disableClear: PropTypes.bool,
        disableRun: PropTypes.bool,
        onChangeUser: PropTypes.func,
        onClear: PropTypes.func,
        onChangeTab: PropTypes.func,
        onRun: PropTypes.func,
        onToggle: PropTypes.func,
        open: PropTypes.bool,
        selectedUser: PropTypes.string,
        showUserActions: PropTypes.bool,
    };
    ConsoleHeader.defaultProps = {
        disableClear: true,
        disableRun: false,
        onChangeUser: function () { },
        onClear: function () { },
        onChangeTab: function () { },
        onRun: function () { },
        onToggle: function () { },
        open: false,
        selectedUser: undefined,
        showUserActions: false,
    };
    return ConsoleHeader;
})();

var bound = function (value, min, max) { return Math.min(Math.max(min, value), max); };
function resultArrayToString(resultArr) {
    var resultStr = '';
    resultArr.forEach(function (_a) {
        var _b, _c, _d, _e, _f;
        var timestamp = _a.timestamp, stats = _a.stats, result = _a.result, error = _a.error, pending = _a.pending, logs = _a.logs, errorLogs = _a.errorLogs, rawError = _a.rawError;
        resultStr += "\n> ran at " + timestamp + "\n";
        if (!pending) {
            if (stats) {
                resultStr += "> took " + stats.executionTime + "\n";
            }
            if (logs === null || logs === void 0 ? void 0 : logs.length) {
                resultStr += "> logs: \n" + logs.join('\n') + "\n";
            }
            if (errorLogs === null || errorLogs === void 0 ? void 0 : errorLogs.length) {
                resultStr += "> error logs: \n" + errorLogs.join('\n') + "\n";
            }
            if (!error) {
                var stringified = JSON.stringify(result, null, 2);
                var stringifiedJS = JSON.stringify(result, null, 0).replace(/'/, "\\'");
                resultStr += "> result: \n" + stringified + "\n";
                resultStr += "> result (JavaScript): \nEJSON.parse('" + stringifiedJS + "')\n";
            }
            if (error) {
                var errorSet = false;
                if (rawError === null || rawError === void 0 ? void 0 : rawError.json) {
                    var details = {};
                    if ((_b = rawError.json) === null || _b === void 0 ? void 0 : _b.admin_error_details) {
                        details = rawError.json.admin_error_details;
                    }
                    // TODO: The format of this will surely change with the inclusion of the 4.0 Admin SDK
                    if (details === null || details === void 0 ? void 0 : details.stats) {
                        resultStr += "> took " + details.stats.execution_time + "\n";
                    }
                    if ((_c = rawError.json) === null || _c === void 0 ? void 0 : _c.admin_error) {
                        errorSet = true;
                        resultStr += "> error: \n" + rawError.json.admin_error + "\n";
                    }
                    if ((_d = details.details) === null || _d === void 0 ? void 0 : _d.stack_trace) {
                        resultStr += "> trace: \n" + details.details.stack_trace + "\n";
                    }
                    if ((_e = details.logs) === null || _e === void 0 ? void 0 : _e.length) {
                        resultStr += "> logs: \n" + details.logs.join('\n') + "\n";
                    }
                    if ((_f = details.error_logs) === null || _f === void 0 ? void 0 : _f.length) {
                        resultStr += "> error logs: \n" + details.error_logs.join('\n') + "\n";
                    }
                }
                if (!errorSet) {
                    resultStr += "> error: \n" + error + "\n";
                }
            }
        }
    });
    return resultStr;
}
var DebugConsole = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(DebugConsole, _super);
            function DebugConsole() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    activeTab: CONSOLE_TAB,
                    resizing: false,
                };
                _this.setActiveTab = function (activeTab, e) {
                    _this.setState({ activeTab: activeTab });
                    if (_this.props.open && e) {
                        e.stopPropagation();
                    }
                };
                _this.execute = function () {
                    if (_this.props.disableRun) {
                        return Promise.resolve();
                    }
                    return _this.props
                        .onRunConsoleSource()
                        .then(function () { return _this.setActiveTab(RESULT_TAB); })
                        .catch(function (err) {
                        _this.setActiveTab(RESULT_TAB);
                        throw err;
                    });
                };
                _this.runFunction = function () {
                    if (!_this.props.open) {
                        _this.toggleConsole(_this.props.open);
                    }
                    return _this.execute();
                };
                // handleResizeMouseMove is added to the window after the user has clicked on the top bar of the console
                // this handles changing the height of the editor
                _this.handleResizeMouseMove = function (e) {
                    if (_this.state.resizing) {
                        _this.props.onResizeHeight(_this.props.height - (e.movementY || 0));
                    }
                };
                // handleResizeMouseUp is added to the window after the user has clicked on the top bar of the console
                // this is responsible for removing the handlers that were added by handleResizeMouseDown
                _this.handleResizeMouseUp = function () {
                    // enable client highliting when resize is over
                    document.body.style.userSelect = '';
                    if (_this.props.open && _this.state.resizing) {
                        _this.setState(function () { return ({
                            resizing: false,
                        }); }, function () {
                            // reset the height to the min or max value on mouse up if it is out of bounds
                            _this.props.onResizeHeight(bound(_this.props.height, _this.props.minHeight, _this.props.maxHeight));
                        });
                        window.dispatchEvent(makeDOMEvent('resize'));
                    }
                    window.removeEventListener('mousemove', _this.handleResizeMouseMove);
                    window.removeEventListener('mouseup', _this.handleResizeMouseUp);
                };
                // handleResizeMouseDown adds two handlers responible for resizing the editor and removing the handlers respectively
                _this.handleResizeMouseDown = function () {
                    // disable client highliting to avoid highlighting while resizing
                    document.body.style.userSelect = 'none';
                    if (_this.props.open) {
                        _this.setState({ resizing: true });
                        window.addEventListener('mousemove', _this.handleResizeMouseMove);
                        window.addEventListener('mouseup', _this.handleResizeMouseUp);
                    }
                };
                _this.toggleConsole = function (open) {
                    if (!_this.state.resizing) {
                        _this.props.onToggle(!open);
                    }
                };
                return _this;
            }
            DebugConsole.prototype.render = function () {
                var _this = this;
                var _a = this.props, disableRun = _a.disableRun, onChangeUser = _a.onChangeUser, open = _a.open, selectedUser = _a.selectedUser, debugConsoleSource = _a.debugConsoleSource, debugResultSource = _a.debugResultSource, onSourceChange = _a.onSourceChange, onClearResult = _a.onClearResult, showUserActions = _a.showUserActions, rest = __rest(_a, ["disableRun", "onChangeUser", "open", "selectedUser", "debugConsoleSource", "debugResultSource", "onSourceChange", "onClearResult", "showUserActions"]);
                var disableClearResult = disableRun || !open || this.state.activeTab !== RESULT_TAB;
                var debugResultSourceString = resultArrayToString(debugResultSource);
                var editorStyle = {
                    // prevent an edge case where maxHeight from parent component has not yet been computed
                    height: this.props.maxHeight > 0
                        ? bound(this.props.height, this.props.minHeight, this.props.maxHeight)
                        : this.props.height,
                };
                var consoleOrResult = this.state.activeTab === CONSOLE_TAB ? (React.createElement("div", { className: "debug-console-editor", style: editorStyle },
                    React.createElement(RichJavascriptEditor, { id: "debugConsole", height: "100%", width: "100%", showBorder: false, showGutter: false, value: debugConsoleSource, onChange: onSourceChange, onSubmit: this.execute }))) : (React.createElement("div", { className: "debug-console-result", style: editorStyle },
                    React.createElement(RichJavascriptEditor, { id: "debugResult", width: "100%", height: "100%", mode: "json", readOnly: true, scrollToBottomOnUpdate: true, showBorder: false, showGutter: false, value: debugResultSourceString })));
                return (React.createElement("div", __assign({ className: "debug-console-container" }, passThroughProps(rest)),
                    React.createElement(ConsoleDrawer, { headerContent: React.createElement(ConsoleHeader, { disableClear: disableClearResult, disableRun: disableRun, onClear: onClearResult, onChangeTab: this.setActiveTab, onRun: this.runFunction, onChangeUser: onChangeUser, onToggle: function () { return _this.toggleConsole(open); }, open: open, selectedUser: selectedUser, activeTab: this.state.activeTab, showUserActions: showUserActions }), open: open, resizing: this.state.resizing, handleResizeMouseDown: function () { return _this.handleResizeMouseDown(); } }, consoleOrResult)));
            };
            return DebugConsole;
        }(Component)),
        _a.propTypes = {
            debugConsoleSource: PropTypes.string,
            debugResultSource: PropTypes.array,
            disableRun: PropTypes.bool,
            height: PropTypes.number.isRequired,
            onChangeUser: PropTypes.func,
            onClearResult: PropTypes.func,
            onResizeHeight: PropTypes.func,
            onRunConsoleSource: PropTypes.func,
            onSourceChange: PropTypes.func,
            onToggle: PropTypes.func,
            open: PropTypes.bool,
            maxHeight: PropTypes.number.isRequired,
            minHeight: PropTypes.number.isRequired,
            selectedUser: PropTypes.string,
            showUserActions: PropTypes.bool,
        },
        _a.defaultProps = {
            disableRun: false,
            debugConsoleSource: '',
            debugResultSource: [],
            onChangeUser: function () { },
            onClearResult: function () { },
            onResizeHeight: function () { },
            onRunConsoleSource: function () { return Promise.resolve(); },
            onSourceChange: function () { },
            onToggle: function () { },
            open: false,
            selectedUser: '',
            showUserActions: false,
        },
        _a.resultArrayToString = resultArrayToString,
        _a;
})();

var css_248z = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.function-editor {\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  flex-flow: column;\n  height: calc(100vh - 250px);\n  min-height: 300px;\n}\n.function-editor-fullscreen {\n  top: 60px;\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  height: calc(100vh - 210px);\n  width: 100%;\n  min-height: 300px;\n}\n.function-editor-source-editor {\n  border: 1px solid #bfbfbe;\n  border-bottom: 0;\n}\n.function-editor-source-editor-container {\n  flex: 1 1 0;\n}\n.function-editor-add-dependency-button {\n  padding-bottom: 20px;\n  justify-content: flex-end;\n  display: flex;\n}\n";
styleInject(css_248z);

var sourceEditorClassName = 'function-editor-source-editor';
var DEBUG_CONSOLE_RATIO = 0.5;
var DEBUG_CONSOLE_MIN_HEIGHT = 15;
var defaultProps = {
    debugConsoleSource: '',
    debugResultSource: [],
    defaultDebugSource: CONSOLE_SOURCE_DEFAULT,
    executingDebugSource: false,
    functionInput: '',
    isFullscreen: false,
    onChangeUser: function () { },
    onClearDebugResult: function () { },
    onClearDebugSource: function () { },
    onRunDebug: function () { return Promise.resolve(); },
    onSave: function () { },
    onUpdateDebugSource: function (_source) { },
    onUpdateEditor: function (_source) { },
    selectedUser: '',
    showUserActions: false,
    showAddDependency: false,
    dependenciesListLink: '',
    installedViaArchive: false,
};
var FunctionEditor = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.functionEditorDiv = React.createRef();
                _this.debugConsoleMaxHeight = 0;
                _this.state = {
                    openConsole: false,
                    debugConsoleHeight: 100,
                    openDependencyDialog: false,
                };
                _this.onFunctionSourceChange = function (source) {
                    _this.props.onUpdateEditor(source);
                };
                _this.onDebugConsoleSourceChange = function (source) {
                    _this.props.onUpdateDebugSource(source);
                };
                _this.onResizeHeight = function (debugConsoleHeight) {
                    _this.setState(function () { return ({ debugConsoleHeight: debugConsoleHeight }); });
                };
                _this.toggleConsole = function (openConsole) {
                    _this.setState({ openConsole: openConsole });
                };
                _this.setAddDependencyDialogIsOpen = function (openDependencyDialog) {
                    _this.setState({ openDependencyDialog: openDependencyDialog });
                };
                return _this;
            }
            class_1.prototype.componentDidMount = function () {
                this.props.onUpdateDebugSource(this.props.defaultDebugSource);
            };
            class_1.prototype.componentDidUpdate = function (prevProps, prevState) {
                if (this.state.openConsole !== prevState.openConsole && window && window.dispatchEvent) {
                    window.dispatchEvent(makeDOMEvent('resize'));
                }
                if (this.functionEditorDiv && this.functionEditorDiv.current) {
                    var debugConsoleMaxHeight = parseFloat(window.getComputedStyle(this.functionEditorDiv.current).getPropertyValue('height')) *
                        DEBUG_CONSOLE_RATIO;
                    if (!Number.isNaN(debugConsoleMaxHeight)) {
                        this.debugConsoleMaxHeight = debugConsoleMaxHeight;
                    }
                }
            };
            class_1.prototype.componentWillUnmount = function () {
                this.props.onClearDebugSource();
                this.props.onClearDebugResult();
            };
            class_1.prototype.render = function () {
                var _this = this;
                var _a = this.props, onClearDebugResult = _a.onClearDebugResult, debugConsoleSource = _a.debugConsoleSource, debugResultSource = _a.debugResultSource, onRunDebug = _a.onRunDebug, executingDebugSource = _a.executingDebugSource, functionInput = _a.functionInput, isFullscreen = _a.isFullscreen, onSave = _a.onSave, selectedUser = _a.selectedUser, onChangeUser = _a.onChangeUser, showUserActions = _a.showUserActions, onToggleFullscreen = _a.onToggleFullscreen, showAddDependency = _a.showAddDependency, dependenciesListLink = _a.dependenciesListLink, onAddDependency = _a.onAddDependency, installedViaArchive = _a.installedViaArchive, rest = __rest(_a, ["onClearDebugResult", "debugConsoleSource", "debugResultSource", "onRunDebug", "executingDebugSource", "functionInput", "isFullscreen", "onSave", "selectedUser", "onChangeUser", "showUserActions", "onToggleFullscreen", "showAddDependency", "dependenciesListLink", "onAddDependency", "installedViaArchive"]);
                var debugConsoleProps = {
                    onChangeUser: onChangeUser,
                    selectedUser: selectedUser,
                    debugConsoleSource: debugConsoleSource,
                    debugResultSource: debugResultSource,
                    disableRun: executingDebugSource,
                    onToggle: this.toggleConsole,
                    open: this.state.openConsole,
                    onSourceChange: this.onDebugConsoleSourceChange,
                    onRunConsoleSource: function () { return onRunDebug(functionInput, debugConsoleSource); },
                    onClearResult: onClearDebugResult,
                    height: this.state.debugConsoleHeight,
                    maxHeight: this.debugConsoleMaxHeight,
                    minHeight: DEBUG_CONSOLE_MIN_HEIGHT,
                    onResizeHeight: this.onResizeHeight,
                    showUserActions: showUserActions,
                };
                var editorClassName = classNames({
                    'function-editor-fullscreen': isFullscreen,
                    'function-editor': !isFullscreen,
                });
                return (React.createElement("div", __assign({ className: editorClassName, ref: this.functionEditorDiv }, passThroughProps(rest)),
                    showAddDependency && onAddDependency && (React.createElement(React.Fragment, null,
                        React.createElement(AddDependencyDialog, { open: this.state.openDependencyDialog, onClose: function () { return _this.setAddDependencyDialogIsOpen(false); }, onAdd: onAddDependency, dependenciesListLink: dependenciesListLink, installedViaArchive: installedViaArchive }),
                        React.createElement("div", { className: "function-editor-add-dependency-button" },
                            React.createElement(Button, { variant: "default", onClick: function () { return _this.setAddDependencyDialogIsOpen(true); } }, "Add Dependency")))),
                    React.createElement("div", { className: sourceEditorClassName + "-container" },
                        React.createElement(RichJavascriptEditor, { className: sourceEditorClassName, height: "100%", id: "editorObject", isExpandable: !!onToggleFullscreen, showBorder: false, toggleFullscreen: onToggleFullscreen, value: functionInput, width: "100%", onChange: this.onFunctionSourceChange, onSave: onSave })),
                    React.createElement(DebugConsole, __assign({}, debugConsoleProps))));
            };
            return class_1;
        }(Component)),
        _a.propTypes = {
            debugConsoleSource: PropTypes.string,
            debugResultSource: PropTypes.array,
            defaultDebugSource: PropTypes.string,
            executingDebugSource: PropTypes.bool,
            functionInput: PropTypes.string,
            isFullscreen: PropTypes.bool,
            onChangeUser: PropTypes.func,
            onClearDebugResult: PropTypes.func,
            onClearDebugSource: PropTypes.func,
            onRunDebug: PropTypes.func,
            onSave: PropTypes.func,
            onUpdateDebugSource: PropTypes.func,
            onUpdateEditor: PropTypes.func,
            selectedUser: PropTypes.string,
            showUserActions: PropTypes.bool,
            showAddDependency: PropTypes.bool,
            dependenciesListLink: PropTypes.string,
            installedViaArchive: PropTypes.bool,
        },
        _a.defaultProps = defaultProps,
        _a;
})();

export { FunctionEditor as default };
//# sourceMappingURL=FunctionEditor-9e94f901.js.map
